import {useCallback, useState} from 'react'
import {useController, useFormContext} from 'react-hook-form'

import {useFormUserEventHandler} from '../../lib/metrika'
import type {BusinessPlateProps} from './BusinessPlate'

export function useBusinessPlate({name, metricaLabel}: BusinessPlateProps) {
  const {control} = useFormContext()
  const {field, fieldState} = useController({control, name, defaultValue: false})
  const [isActionButtonClicked, setIsActionButtonClicked] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const handleReachGoal = useFormUserEventHandler()
  const showSwitch = field.value || isActionButtonClicked

  const toggleModal = useCallback(() => {
    setIsModalOpen(prevState => !prevState)
  }, [])

  const handleChange = useCallback(
    (value: boolean) => {
      metricaLabel && handleReachGoal(metricaLabel)
      !isActionButtonClicked && setIsActionButtonClicked(true)
      field.onChange(value)
    },
    [field, handleReachGoal, isActionButtonClicked, metricaLabel],
  )

  const handleActionButtonClick = useCallback(() => {
    setIsActionButtonClicked(true)
    handleChange(true)
    toggleModal()
  }, [handleChange, setIsActionButtonClicked, toggleModal])

  return {
    field,
    fieldState,
    isModalOpen,
    showSwitch,
    toggleModal,
    handleChange,
    handleActionButtonClick,
  } as const
}
